import React from 'react';
import styled from '@emotion/styled';

import { Divider, Anchor, Text } from '../../atoms';
import { useUserContext } from '../../../contexts/UserContext';
import theme from '../../../styles/theme';

const NotificationWrapper = styled.div`
  padding: 10px;
  text-decoration: none;

  color: ${({ seen }) => (seen ? theme.colors.gray500 : 'inherit')};
`;

const Notifications = () => {
  const {
    user: { notifications },
  } = useUserContext();

  return notifications?.length > 0 ? (
    notifications
      .filter((noti) => noti.comment)
      .map((noti) => (
        <React.Fragment key={noti._id}>
          <Anchor to={`/question/${noti.post}`}>
            <Divider />
            <NotificationWrapper seen={noti.seen}>
              질문에 대한 답변이 달렸어요! &quot;{noti.comment.comment}
              &quot;
            </NotificationWrapper>
          </Anchor>
        </React.Fragment>
      ))
  ) : (
    <>
      <Divider />
      <Text>알림이 없습니다.</Text>
    </>
  );
};

export default Notifications;
